export interface AppConfig {
  ENVIRONMENT: 'dev' | 'pre' | 'prod';
}

export const loadConfig = async (): Promise<AppConfig> => {
  const response = await fetch('/env-config.json');
  if (!response.ok) throw new Error('No se pudo cargar la configuración');
  return response.json();
}; 